import { KTIcon } from '@/_metronic/helpers'
import {useListView} from '../../../core/ListViewProvider'

const ProductRelationModalHeader = () => {
  const {itemId, setItemId, itemIdForUpdate} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{itemId == null? 'Add' : itemIdForUpdate === 1 ? "View" : "Edit"} Product Relation</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemId!(undefined!)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {ProductRelationModalHeader}
